import {
  GET_PVS_DETAILS_REQUEST,
  GET_PVS_DETAILS_SUCCESS,
  GET_PVS_DETAILS_FAILURE,
  GET_PVS_DETAILS_RESET,
} from "../../../types/pvs"

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
}

const getPvsDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PVS_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: "",
      }

    case GET_PVS_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message:
          (action.payload && action.payload.message) ||
          "PVS registration verified successfully",
      }

    case GET_PVS_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        success: false,
        message: action.payload && action.payload.message,
      }

    case GET_PVS_DETAILS_RESET:
      return {
        ...initialState,
      }

    default:
      return state
  }
}

export default getPvsDetailsReducer
